import { GetterTree } from 'vuex';

// Shared types
import { Company, Texts } from '@coldtec/cos-types';

// Store types
import { RootState, CompanyGetter } from '@/store/store.types';

/**
 *  Holding every getter of the company.
 */
export const Getters: GetterTree<RootState, RootState> = {

    /**
     *  Used to get the details of the company for which the tool is loaded.
     */
    [CompanyGetter.DETAILS](state: RootState): Company | null {

        return state.company.details;

    },

    /**
     *  Used to get the texts of the company.
     */
    [CompanyGetter.TEXTS](state: RootState): Texts {

        if (!state.company.details || !state.company.details.texts) {

            return {};

        }

        return state.company.details.texts;

    },

};
